import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from '@components/toolbar';
import { ButtonModule } from '@components/button';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { RouterModule } from '@angular/router';
import { authenticationGuard } from '../guards/authentication.guard';
import { onboardingGuard } from '../guards/onboarding.guard';
import { IsotretinoinConsentForm } from './isotretinoin-consent-form/isotretinoin-consent-form.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([{
        path: 'isotretinoin-consent-form', canActivate: [authenticationGuard, onboardingGuard], component: IsotretinoinConsentForm,
    }]),
    ToolbarModule,
    ButtonModule,
    LoadingModule,
    CsIconModule,
  ],
  declarations: [IsotretinoinConsentForm],
})
export class ConsentFormModule { }
